<template>
  <TextInput
    class="grow w-full max-w-full"
    size="md"
    v-model="searchTerm"
    :autoFocus="true"
    :placeholder="placeholder"
    @update:modelValue="emit('update:modelValue', searchTerm)"
  >
    <template #start>
      <Icon name="search" class="fg-quaternary" />
    </template>
    <template #end>
      <Icon
        v-if="!isEmpty(searchTerm)"
        @click="clear"
        name="close"
        size="sm"
        class="cursor-pointer fg-quaternary"
      />
    </template>
  </TextInput>
</template>

<script setup>
// Libraries
import { ref } from "vue";
import { isEmpty } from "lodash";

// Components
import { TextInput } from "@/SharedComponents/Inputs";
import { Icon } from "@/SharedComponents/Icon";

// Emits
const emit = defineEmits(["update:modelValue"]);

// Props
defineProps({
  placeholder: {
    type: String,
    default: "",
  },
});

// Refs
const searchTerm = ref("");

// Functions
const clear = () => {
  searchTerm.value = "";
  emit("update:modelValue", searchTerm.value);
};
</script>
